class App
	cache = {leveldays: {}}

	lg = self.langDetect()

	translate = [
		{ru: '', en: ''}
	]

	trans = {
		devs: ['DEVELOPED BY GENOPETS FAN COMMUNITY IN TELEGRAM', 'Разработано фан-сообществом Genopets в телеграм'],
		join: ['Join Now', 'Присоединиться'],
		tab1: ['Harvest KI', 'Сбор KI']
		tab2: ['Genopet LevelUp', 'Левелап Генопета']
		tab3: ['Decoder', 'Дешифратор']
		tab11: ['Harvest KI from Steps', 'Кол-во KI за шаги']
		tab12: ['Steps for Harvest KI', 'Шаги для сбора KI']
		tab21: ['Days to Leveling Up', 'Дней для повышения уровня']
		tab22: ['Cost a Leveling Up', 'Стоимость повышения уровня']
		in-st: ['Your Daily Steps', 'Ваши ежедневные шаги']
		in-le: ['Your Genopet level', 'Уровень вашего Генопета']
		in-curle: ['Current Your Genopet level', 'Текущий уровень вашего Генопета']
		in-tarle: ['Target Genopet level', 'Желаемый уровень Генопета']
		gen-hab: ['General Habitat', 'Главный Хабитат']
		sub-hab: ['Subhabitat', 'Субхабитат']
		type-gen: ['Genesis', 'Генезис']
		type-nor: ['Normal', 'Обычный']
		level: ['lvl', 'лвл']
		switch: ['Subtract energy to Harvest KI', 'Учитывать энергию на сбор KI']
		en-earn: ['Energy Earned', 'Энергии заработано']
		en-need: ['Energy Needed', 'Энергии необходимо']
		ki-cap: ['Ki Max Cap', 'KI максимум']
		ki14: ['Ki with 14 days lock', 'KI с блокировкой на 14 дней']
		ki10: ['Ki with 10 days lock', 'KI с блокировкой на 10 дней']
		ki7: ['Ki with 7 days lock', 'KI с блокировкой на 7 дней']
		ki-harv: ['KI Harvest', 'KI будет собрано']
		steps14: ['Steps with 14 day Ki lock', 'Шагов с блокировкой KI на 14 дней']
		steps10: ['Steps with 10 day Ki lock', 'Шагов с блокировкой KI на 10 дней']
		steps7: ['Steps with 7 day Ki lock', 'Шагов с блокировкой KI на 7 дней']
		days-noki: ['Days without Harvest KI', 'Дней без сбора KI']
		days14: ['Days with 14 day KI Lock', 'Дней с блокировкой KI на 14 дней']
		days10: ['Days with 10 day KI Lock', 'Дней с блокировкой KI на 10 дней']
		days7: ['Days with 7 day KI Lock', 'Дней с блокировкой KI на 7 дней']
		dec-clear: ['Clear', 'Очистить']
		dec-space: ['Space', 'Пробел']
		dec-caesar: ['Caesar shift', 'Сдвиг Цезаря']
		slogan: ['Move. Play. Earn.', 'Двигайся. Играй. Зарабатывай.']
	}

	rates = {sol: 0, ki: 0, gene: 0}

	habs = [
		# HARVEST KI FROM STEPS
		{onoff: true, type: 'gen', lvl: 0, sub: false}
		{onoff: false, type: 'gen', lvl: 0, sub: true}
		{onoff: false, type: 'gen', lvl: 0, sub: true}
		# STEPS FOR HARVEST KI
		{onoff: true, type: 'gen', lvl: 0, sub: false}
		{onoff: false, type: 'gen', lvl: 0, sub: true}
		{onoff: false, type: 'gen', lvl: 0, sub: true}
		# STEPS FOR GENOPET LEVEL
		{onoff: true, type: 'gen', lvl: 0, sub: false}
		{onoff: false, type: 'gen', lvl: 0, sub: true}
		{onoff: false, type: 'gen', lvl: 0, sub: true}
	]

	ser = [1, 4.2, 7.4, 10.6, 13.8, 17, 20.2, 23.4, 26.6, 29.8, 33, 36.2, 39.4, 42.6, 45.8, 49, 52.2, 55.4, 58.6, 61.8, 65, 66.05, 66.1, 66.15, 66.2, 66.25, 66.3, 66.35, 66.4, 66.45, 66.5, 66.55, 66.6, 66.65, 66.7, 66.75, 66.8, 66.85, 66.9, 66.95, 67, 67.05, 67.1, 67.15, 67.2, 67.25, 67.3, 67.35, 67.4, 67.45, 67.5, 67.55, 67.6, 67.65, 67.7, 67.75, 67.8, 67.85, 67.9, 67.95, 68, 68.05, 68.1, 68.15, 68.2, 68.25, 68.3, 68.35, 68.4, 68.45, 68.5, 68.55, 68.6, 68.65, 68.7, 68.75, 68.8]
	requiredXP = [1020, 1504, 1774, 2094, 2471, 3307, 4394, 5896, 7797, 10312, 11859, 13637, 15683, 18035, 22879, 25396, 28189, 31290, 34732, 42793, 53491, 66233, 74002, 89543, 98497, 108347, 119182, 131100, 111671, 121722, 132677, 144618, 157633, 171820, 187284, 147853, 159682, 172456, 186253, 201153, 217245, 234625, 171443, 183444, 196285, 210025, 224726, 240457, 257289, 275299, 294570, 315190, 337253, 360861, 386122, 413150, 442071, 473015, 506127, 541555, 579464, 620027, 663429, 709869, 759559, 812729, 869620, 930493, 995627, 1065321, 1139894, 1219686, 1305065, 1396419, 1494168, 1598760]
	cumulativeXP = [0, 1020, 2524, 4298, 6392, 8863, 12170, 16565, 22460, 30258, 40569, 52428, 66065, 81748, 99783, 122662, 148058, 176247, 207537, 242269, 285062, 338554, 404787, 478789, 568332, 666829, 775176, 894358, 1025458, 1137129, 1258851, 1391528, 1536146, 1693779, 1865599, 2052883, 2200736, 2360418, 2532874, 2719127, 2920280, 3137525, 3372150, 3543593, 3727037, 3923322, 4133347, 4358073, 4598530, 4855819, 5131118, 5425688, 5740878, 6078131, 6438992, 6825114, 7238264, 7680335, 8153350, 8659477, 9201032, 9780496, 10400523, 11063952, 11773821, 12533380, 13346109, 14215729, 15146222, 16141849, 17207170, 18347064, 19566750, 20871815, 22268234, 23762402]

	# разрядность чисел
	def SpaceNum number 
		return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")

	# steps for energy
	def StepsForEnergy en, le
		let lvl = le
		lvl = 77 if lvl > 77
		lvl = 1 if lvl < 1
		let sef = (70 - (ser[lvl - 1] - 1)) / 100
		let res2 = 0
		for i in [1 .. 200000]
			res2 += (1 - sef) ** Math.floor((i - 1) / 1000)
			# if en < 1
			# 	energy = 1
			return i if res2 >= en
		return '200k+'

	# energy from steps
	def EnergyFromSteps st, le
		let lvl = le
		lvl = 77 if lvl > 77
		lvl = 1 if lvl < 1
		let sef = (70 - (ser[lvl - 1] - 1)) / 100
		let res1 = 0
		for i in [1 .. st]
			res1 += (1 - sef) ** Math.floor((i - 1) / 1000)
		return Math.round(res1)

	# кол-во шагов на улучшение до след уровня
	def NextLevel level, daily, coef
		let lvl = level
		lvl = 77 if lvl > 77
		lvl = 1 if lvl < 1
		let sef = (70 - (ser[lvl - 1] - 1)) / 100
		let res = 0
		for k in [1 .. daily]
			res += sef ** Math.floor((k - 1) / 1000)
		if coef
			return requiredXP[lvl] / (res - self.HabEnergy(coef))
		return requiredXP[lvl] / res
	
	def LevelDays current, desire, dailysteps, coef
		if dailysteps > 100000
			return "It's a Ban"
		# if cache.leveldays["{current}-{desire}-{dailysteps}-{coef}"]
		# 	return Math.ceil(cache.leveldays["{current}-{desire}-{dailysteps}-{coef}"])
		let res = 0
		for i in [current ... desire]
			res += self.NextLevel(i, dailysteps, coef)
		if res < coef
			return '∅'
		# cache.leveldays["{current}-{desire}-{dailysteps}-{coef}"] = res
		return Math.ceil(res)
	
	def HabEnergy perc
		let energy = self.DailyCap(6) / perc
		return energy

	def DailyCap start
		let rate = {gen: [40, 60, 80], norm: [30, 50, 70]}
		let sum = 0
		let count = 0 
		for hab, id in habs when hab.onoff and id >=start and id <=start + 2
			sum += rate[hab.type][hab.lvl]
			count++
		sum *= 1.1 if count > 1
		return Math.round(sum)

	def fetchRate token
		let url = "https://price.jup.ag/v1/price?id={token}"
		let response = await window.fetch(url)
		if response.ok
			rates[token] = (await response.json!).data.price
		imba.commit!
		setTimeout(&, 30000) do fetchRate!

	def langDetect
		let lang = window.navigator.language
		if lang  == "ru-RU"
			return 1
		return 0

	def constructor
		for own key of rates
			fetchRate(key)
		langDetect()

export const app = new App